/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatteryState } from './BatteryState';
/**
 * Configuration that can change characteristics of the battery.
 */
export type BatteryConfiguration = {
    component_config_type?: BatteryConfiguration.component_config_type;
    state?: BatteryState;
};
export namespace BatteryConfiguration {
    export enum component_config_type {
        BATTERY = 'battery',
    }
}

